'use strict';

angular.module('docketbook')
  .controller('connectionsController', function (addressBookService, $rootScope, splitListInterface, $scope, userService, $window, Restangular, $state, $stateParams, accessControl, uuid, $q) {

    $scope.query = {
      limit: 30,
      page: 1,
      order: 'displayName'
    }
    $scope.promise = null;
    $scope.connectionEdit = null

    $scope.connections = []
    $scope.selected = []
    $scope.currentOrg = accessControl.currentOrg();



    /** Details **/
    $scope.splitListFunc = new splitListInterface($scope, $stateParams)

    $scope.openConnection = function (connection) {
      if (connection.targetId == null && connection.sourceId != $scope.currentOrg.id) {
        $scope.showAcceptConnectionModal(connection, function () {
          $scope.loadConnections()
          $rootScope.updateScopeNavConnections()
        });
        return;
      }

      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.connectionEdit = angular.copy(connection);
    }


    $scope.closeConnection = function () {
      $scope.contactEdit = null
      $scope.splitListFunc.slideTableListDetailClosed()
    }

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    $scope.acceptConnection = function (connection) {
      connection.status = 'accept'

      addressBookService.saveInvitation(connection,
        function (updatedConnection) {
          $scope.loadConnections()
          $scope.openConnection(updatedConnection)
        },
        function (err) {
          $scope.alertService.presentAutoAlert('saveConnection', err);
        }
      )
    }

    /****/

    $scope.getConnectionStatus = (connection) => {
      if (connection == null) return ''

      switch (connection.status) {
        case 'requested': {
          if (connection.sourceId != $scope.currentOrg.id) {
            return 'Request received'
          } else {
            return 'Request sent'
          }
        }
        case 'accepted':
          return 'Connected'
        case 'declined':
          return 'Declined'
      }
    }

    $scope.rejectConnection = function (connection) {
      swal({
        title: "Are you sure?",
        text: `Do you really want to decline the connection with ${connection.company}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, decline it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          connection.status = 'decline'
          addressBookService.saveInvitation(connection,
            function () {
              $scope.loadConnections()
              $rootScope.updateScopeNavConnections()
            },
            function (err) {
              swal("Oops", "Something went wrong", "warning");
              $scope.alertService.presentAutoAlert('saveConnection', err);
            }
          )
        }
      })
    }

    $scope.deleteConnection = function (connection) {
      swal({
        title: "Are you sure?",
        text: `Do you really want to delete the connection with ${connection.companyName}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          addressBookService.removeConnection(connection,
            function () {
              $scope.closeConnection()
              $scope.loadConnections()
              $rootScope.updateScopeNavConnections()
            },
            function (err) {
              swal("Oops", "Something went wrong", "warning");
              $scope.alertService.presentAutoAlert('saveConnection', err);
            }
          )
        }
      })
    }

    $scope.cancelRequestedConnection = function (connection) {
      swal({
        title: "Are you sure?",
        text: `Do you really want to cancel the requested connection${connection.companyName ? (' with ' + connection.companyName) : ''}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          addressBookService.removeConnection(connection,
            function () {
              $scope.closeConnection()
              $scope.loadConnections()
            },
            function (err) {
              swal("Oops", "Something went wrong", "warning");
              $scope.alertService.presentAutoAlert('saveConnection', err);
            }
          )
        }
      })
    }

    $scope.newConnection = function () {
      $scope.showCreateConnectionsModal(false, function () { $scope.loadConnections() })
    }

    $scope.importConnections = function () {
      $scope.showCreateConnectionsModal(true, function () { $scope.loadConnections() })
    }

    function getUserConnections(cb) {
      function addToConnections(connections) {
        userService.getUserInvitations(function (invitations) {
          invitations.forEach(invitation => {
            const foundConnection = connections.find(conn => conn.id == invitation.connectionId)
            if (foundConnection) {
              foundConnection.invitation = invitation
            }
          })
          cb(connections)
        }, () => cb([]))
      }
      userService.getUserConnections(addToConnections, () => cb([]))
    }


    function getRelevantInvitations() {
      return $q(function (resolve, reject) {
        if ($scope.connections.length > 0) {
          // Link invitations to connections
          addressBookService.getFilteredInvitations({ connectionIds: $scope.connections.map(conn => conn.id) }, function (invitations) {
            invitations.forEach(invitation => {
              const foundConnection = $scope.connections.find(conn => conn.id == invitation.connectionId)
              if (foundConnection) {
                foundConnection.invitation = invitation
              }
              resolve('Done')
            })
          }, function (err) {
            reject('Error')
          })
        } else {
          resolve('Done')
        }
      })
    }


    $scope.loadConnections = function () {
      $scope.promise = $q(function (resolve, reject) {
        const { limit, page, order } = $scope.query

        var params = {
          limit,
          offset: limit * (page - 1),
          sort: order,
        }
        if ($scope.search != null && $scope.search != "") {
          params.search = $scope.search;
        }

        addressBookService.getConnections(params, function (connections) {
          $scope.connections = connections

          var count = 0;
          if (params.offset <= 0 && connections.length < params.limit) {
            count = connections.length;
          } else {
            count = params.offset + (params.limit + 1)
          }
          $scope.listCount = count

          getUserConnections(function (userConnections) {
            $scope.connections = connections.concat(userConnections)
            $scope.connections.forEach(conn => conn.invitation = {})

            getRelevantInvitations()
              .then(() => {
                $scope.connections
                  .filter(connection =>
                    (connection.sourceId != $scope.currentOrg.id && connection.status == 'requested')
                    || (connection.status == 'accepted')
                  )
                  .forEach(connection => {
                    connection.invitation.orgData = {}

                    const orgIdToGet = connection.sourceId == $scope.currentOrg.id ? connection.targetId : connection.sourceId
                    userService.getOrgData(orgIdToGet, function (orgData) {
                      connection.orgData = {
                        organisationName: orgData.name,
                        fullName: orgData.contacts[0].name,
                        emailAddress: orgData.contacts[0].emailAddress,
                      }
                    }, function (err) {
                      console.error('could not get organisational data', err)
                    })
                  })
                resolve('Done')
              }).catch(err => {
                reject(err)
              })
          })
        }, function (err) {
          reject('Error')
        })
      })
    }

    $scope.loadConnections()

    $scope.deleteSelectedConnections = function () {
      swal({
        title: "Are you sure?",
        text: `Do you really want to delete the requested connections?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, keep them!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          $q.all(
            $scope.selected.map(connection =>
              $q(resolve => addressBookService.removeConnection(connection, resolve, resolve))
            )
          ).then(() => {
            $scope.loadConnections()
            $rootScope.updateScopeNavConnections()
            $scope.selected = []
          })
        }
      })
    }

  })



// WEBPACK FOOTER //
// ./src/controllers/connections/connectionsController.js